/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecord } from './ActorActivityRecord';
import {
    ActorActivityRecordFromJSON,
    ActorActivityRecordFromJSONTyped,
    ActorActivityRecordToJSON,
    ActorActivityRecordToJSONTyped,
} from './ActorActivityRecord';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ActorChangeHistoryDay
 */
export interface ActorChangeHistoryDay {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ActorChangeHistoryDay
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Date}
     * @memberof ActorChangeHistoryDay
     */
    date: Date;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ActorChangeHistoryDay
     */
    totalCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof ActorChangeHistoryDay
     */
    isTruncated: boolean;
    /**
     * 
     * @type {Array<ActorActivityRecord>}
     * @memberof ActorChangeHistoryDay
     */
    records: Array<ActorActivityRecord>;
}

/**
 * Check if a given object implements the ActorChangeHistoryDay interface.
 */
export function instanceOfActorChangeHistoryDay(value: object): value is ActorChangeHistoryDay {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('isTruncated' in value) || value['isTruncated'] === undefined) return false;
    if (!('records' in value) || value['records'] === undefined) return false;
    return true;
}

export function ActorChangeHistoryDayFromJSON(json: any): ActorChangeHistoryDay {
    return ActorChangeHistoryDayFromJSONTyped(json, false);
}

export function ActorChangeHistoryDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActorChangeHistoryDay {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'date': (new Date(json['date'])),
        'totalCount': ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'isTruncated': json['isTruncated'],
        'records': ((json['records'] as Array<any>).map(ActorActivityRecordFromJSON)),
    };
}

export function ActorChangeHistoryDayToJSON(json: any): ActorChangeHistoryDay {
    return ActorChangeHistoryDayToJSONTyped(json, false);
}

export function ActorChangeHistoryDayToJSONTyped(value?: ActorChangeHistoryDay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'date': value['date'].toISOString().substring(0,10),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'isTruncated': value['isTruncated'],
        'records': ((value['records'] as Array<any>).map(ActorActivityRecordToJSON)),
    };
}

